import { Component } from '@angular/core';

@Component({
  selector: 'i-enter',
  imports: [],
  template: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 26" fill="none">
    <path
      d="M33.082 2.36313C33.082 1.05602 34.138 0 35.4451 0C36.7523 0 37.8083 1.05602 37.8083 2.36313V9.45253C37.8083 13.3665 34.6328 16.5419 30.7189 16.5419H8.06973L13.4902 21.9624C14.4133 22.8855 14.4133 24.3846 13.4902 25.3077C12.5671 26.2308 11.068 26.2308 10.1449 25.3077L0.692324 15.8551C-0.230775 14.932 -0.230775 13.4329 0.692324 12.5098L10.1449 3.0573C11.068 2.1342 12.5671 2.1342 13.4902 3.0573C14.4133 3.9804 14.4133 5.47951 13.4902 6.40261L8.06973 11.8157H30.7189C32.026 11.8157 33.082 10.7596 33.082 9.45253V2.36313Z"
      fill="currentColor"
    />
  </svg>`,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconEnter {}
